import groupBy from 'lodash/groupBy';
import toPairs from 'lodash/toPairs';

class Linq {
    public selectMany(arr, selectFunc) {
        return arr.map((a) => selectFunc(a)).reduce((a, b) => a.concat(b), []);
    }

    public groupBy(arr, groupProperty) {
        return toPairs(groupBy(arr, groupProperty));
    }

    public intersect(array1, array2) {
        return array1.filter((v) => array2.indexOf(v) !== -1);
    }

    public sum(array1, selectFunc) {
        return array1.reduce((a, b) => a + selectFunc(b), 0);
    }

    distinctValues(arr) {
        return [... new Set(arr)];
    }

    distinct(arr, disctintProperty) {
        return toPairs(groupBy(arr, disctintProperty)).map((p) => p[1][0]);
    }

    takeNth(array, n) {
        return array.filter((_, index) => (index % n === 0));
    }
}

const linq = new Linq();
export default linq;
